import { Pipe, PipeTransform } from '@angular/core';
import { resizedTo } from '@plys/src/utils/media.utils';

/**
 * Template access to `resizedTo` — see that function for the sizing rules.
 *
 * - `| plysResize: 56:56`  fills a fixed 56x56 box, cropping the overflow.
 * - `| plysResize: 200`    width only, height follows the source ratio, nothing cropped.
 */
@Pipe({ name: 'plysResize', standalone: true })
export class ResizePipe implements PipeTransform {
  transform(url: string | null | undefined, width: number, height?: number): string | null {
    return resizedTo(url, width, height);
  }
}
